var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('h2',[_vm._v("Oops... Something went wrong")]),_c('div',{staticClass:"link-block"},[_c('router-link',{staticClass:"link",attrs:{"to":"/"}},[_vm._v(" Back on main page ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }